// 店舗内求人選択画面(shops/entry_select)のJS
import { shopEntrySelect } from '@pc/components/ShopEntrySelect'

document.addEventListener('DOMContentLoaded', () => {
  // 応募導線のsubmitインターセプトなので遅延させず即実行
  shopEntrySelect()
})
